import { useEffect } from "react";
import { FcPrint } from "react-icons/fc";
import {
  ContainerV2,
  H1,
  InputRHFV2,
  PaymentCodContainerV2,
} from "../../Atoms";
import { Tracking } from "../../../services/Tracking";
import { reverseToBrDate } from "../../../utils/dateTransform";
import { maskCnpj, maskCpf, maskMoney } from "../../../utils/masks";
import { removeUnderscore } from "../../../utils/removeUnderscore";
import { useInvoiceV2 } from "./useInvoiceV2";

export const InvoiceV2 = () => {
  const { agendamento, pagamento, contaIugu, isPix, isBoleto, handlePrint } =
    useInvoiceV2();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento/fatura:pageview");
  }, []);

  const cpfCnpj = agendamento?.cliente?.cpfCnpj;
  const cpfCnpjMascarado =
    cpfCnpj?.length > 11 ? maskCnpj(cpfCnpj) : maskCpf(cpfCnpj);

  return (
    <ContainerV2 backButton={false} className="max-w-[984px]">
      <div className="flex items-start justify-between gap-4 print:hidden">
        <H1>Dados do Agendamento</H1>

        <button
          type="button"
          onClick={handlePrint}
          className="flex items-center gap-2 font-['Mulish'] text-base font-medium text-[#20332f]"
        >
          <FcPrint size={22} />
          Imprimir Fatura
        </button>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-5">
        <div className="col-span-2 sm:col-span-3">
          <InputRHFV2
            id="status"
            label="Status"
            readOnly
            value={removeUnderscore(agendamento?.status)}
          />
        </div>
        <div>
          <InputRHFV2
            id="data"
            label="Data"
            readOnly
            value={reverseToBrDate(agendamento?.diaAgendado)}
          />
        </div>
        <div>
          <InputRHFV2
            id="horario"
            label="Horário"
            readOnly
            value={agendamento?.horaAgendada}
          />
        </div>

        <div className="col-span-2 sm:col-span-3">
          <InputRHFV2
            id="cliente"
            label="Cliente"
            readOnly
            value={agendamento?.cliente?.nome || "---"}
          />
        </div>
        <div className="col-span-2">
          <InputRHFV2
            id="cpf-cnpj"
            label="CPF/CNPJ"
            readOnly
            value={cpfCnpjMascarado}
          />
        </div>

        <div className="col-span-2 sm:col-span-3">
          <InputRHFV2
            id="modelo"
            label="Modelo do carro"
            readOnly
            value={agendamento?.veiculo?.modelo || "---"}
          />
        </div>
        <div>
          <InputRHFV2
            id="placa"
            label="Placa"
            readOnly
            value={agendamento?.veiculo?.placa || "---"}
          />
        </div>
        <div>
          <InputRHFV2
            id="renavam"
            label="Renavam"
            readOnly
            value={agendamento?.veiculo?.renavam || "---"}
          />
        </div>

        <div className="col-span-2 sm:col-span-5">
          <InputRHFV2
            id="chassi"
            label="Chassi"
            readOnly
            value={agendamento?.veiculo?.chassi || "---"}
          />
        </div>
      </div>

      <H1 className="mt-10">Dados para Pagamento</H1>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <InputRHFV2
          id="cedente"
          label="Cedente"
          readOnly
          value={contaIugu?.nome || "---"}
        />
        <InputRHFV2
          id="cedente-cnpj"
          label="CNPJ"
          readOnly
          value={(contaIugu?.cnpj && maskCnpj(contaIugu.cnpj)) || "---"}
        />
      </div>

      {isPix && (
        <div className="mx-auto mt-10 flex w-full max-w-[740px] min-w-0 flex-col items-center gap-8 md:flex-row md:items-center md:justify-center">
          <img
            src={pagamento?.pix?.qrcode}
            alt="qrcode"
            className="h-[260px] w-[260px] shrink-0 rounded-[10px] border-2 border-solid border-[#12d1a7]"
          />

          <div className="flex w-full min-w-0 flex-col items-center gap-4">
            <p className="font-['Mulish'] text-2xl font-bold text-[#20332f]">
              Valor: {maskMoney((pagamento?.valorTotal ?? 0) / 100)}
            </p>

            <PaymentCodContainerV2 value={pagamento?.pix?.qrcodeText ?? ""} />
          </div>
        </div>
      )}

      {isBoleto && (
        <div className="mx-auto mt-10 flex w-full max-w-[740px] min-w-0 flex-col items-center gap-8">
          <p className="font-['Mulish'] text-2xl font-bold text-[#20332f]">
            Valor: {maskMoney((pagamento?.valorTotal ?? 0) / 100)}
          </p>

          <img
            src={pagamento?.boleto?.barCode}
            alt="codigo de barras"
            className="h-[100px] w-full rounded-[10px] border border-solid border-[#20332f] object-contain"
          />

          <PaymentCodContainerV2 value={pagamento?.boleto?.barCodeData ?? ""} />
        </div>
      )}
    </ContainerV2>
  );
};
